export const timeList = [
  {
    value: "12:00 am",
    stringValue: "0000",
    selected: false,
    disabled: false,
    index: 1
  },
  {
    value: "12:30 am",
    stringValue: "0030",
    selected: false,
    disabled: false,
    index: 2
  },
  {
    value: "1:00 am",
    stringValue: "0100",
    selected: false,
    disabled: false,
    index: 3
  },
  {
    value: "1:30 am",
    stringValue: "0130",
    selected: false,
    disabled: false,
    index: 4
  },
  {
    value: "2:00 am",
    stringValue: "0200",
    selected: false,
    disabled: false,
    index: 5
  },
  {
    value: "2:30 am",
    stringValue: "0230",
    selected: false,
    disabled: false,
    index: 6
  },
  {
    value: "3:00 am",
    stringValue: "0300",
    selected: false,
    disabled: false,
    index: 7
  },
  {
    value: "3:30 am",
    stringValue: "0330",
    selected: false,
    disabled: false,
    index: 8
  },
  {
    value: "4:00 am",
    stringValue: "0400",
    selected: false,
    disabled: false,
    index: 9
  },
  {
    value: "4:30 am",
    stringValue: "0430",
    selected: false,
    disabled: false,
    index: 10
  },
  {
    value: "5:00 am",
    stringValue: "0500",
    selected: false,
    disabled: false,
    index: 11
  },
  {
    value: "5:30 am",
    stringValue: "0530",
    selected: false,
    disabled: false,
    index: 12
  },
  {
    value: "6:00 am",
    stringValue: "0600",
    selected: false,
    disabled: false,
    index: 13
  },
  {
    value: "6:30 am",
    stringValue: "0630",
    selected: false,
    disabled: false,
    index: 14
  },
  {
    value: "7:00 am",
    stringValue: "0700",
    selected: false,
    disabled: false,
    index: 15
  },
  {
    value: "7:30 am",
    stringValue: "0730",
    selected: false,
    disabled: false,
    index: 16
  },
  {
    value: "8:00 am",
    stringValue: "0800",
    selected: false,
    disabled: false,
    index: 17
  },
  {
    value: "8:30 am",
    stringValue: "0830",
    selected: false,
    disabled: false,
    index: 18
  },
  {
    value: "9:00 am",
    stringValue: "0900",
    selected: false,
    disabled: false,
    index: 19
  },
  {
    value: "9:30 am",
    stringValue: "0930",
    selected: false,
    disabled: false,
    index: 20
  },
  {
    value: "10:00 am",
    stringValue: "1000",
    selected: false,
    disabled: false,
    index: 21
  },
  {
    value: "10:30 am",
    stringValue: "1030",
    selected: false,
    disabled: false,
    index: 22
  },
  {
    value: "11:00 am",
    stringValue: "1100",
    selected: false,
    disabled: false,
    index: 23
  },
  {
    value: "11:30 am",
    stringValue: "1130",
    selected: false,
    disabled: false,
    index: 24
  },
  {
    value: "12:00 pm",
    stringValue: "1200",
    selected: false,
    disabled: false,
    index: 25
  },
  {
    value: "12:30 pm",
    stringValue: "1230",
    selected: false,
    disabled: false,
    index: 26
  },
  {
    value: "1:00 pm",
    stringValue: "1300",
    selected: false,
    disabled: false,
    index: 27
  },
  {
    value: "1:30 pm",
    stringValue: "1330",
    selected: false,
    disabled: false,
    index: 28
  },
  {
    value: "2:00 pm",
    stringValue: "1400",
    selected: false,
    disabled: false,
    index: 29
  },
  {
    value: "2:30 pm",
    stringValue: "1430",
    selected: false,
    disabled: false,
    index: 30
  },
  {
    value: "3:00 pm",
    stringValue: "1500",
    selected: false,
    disabled: false,
    index: 31
  },
  {
    value: "3:30 pm",
    stringValue: "1530",
    selected: false,
    disabled: false,
    index: 32
  },
  {
    value: "4:00 pm",
    stringValue: "1600",
    selected: false,
    disabled: false,
    index: 33
  },
  {
    value: "4:30 pm",
    stringValue: "1630",
    selected: false,
    disabled: false,
    index: 34
  },
  {
    value: "5:00 pm",
    stringValue: "1700",
    selected: false,
    disabled: false,
    index: 35
  },
  {
    value: "5:30 pm",
    stringValue: "1730",
    selected: false,
    disabled: false,
    index: 36
  },
  {
    value: "6:00 pm",
    stringValue: "1800",
    selected: false,
    disabled: false,
    index: 37
  },
  {
    value: "6:30 pm",
    stringValue: "1830",
    selected: false,
    disabled: false,
    index: 38
  },
  {
    value: "7:00 pm",
    stringValue: "1900",
    selected: false,
    disabled: false,
    index: 39
  },
  {
    value: "7:30 pm",
    stringValue: "1930",
    selected: false,
    disabled: false,
    index: 40
  },
  {
    value: "8:00 pm",
    stringValue: "2000",
    selected: false,
    disabled: false,
    index: 41
  },
  {
    value: "8:30 pm",
    stringValue: "2030",
    selected: false,
    disabled: false,
    index: 42
  },
  {
    value: "9:00 pm",
    stringValue: "2100",
    selected: false,
    disabled: false,
    index: 43
  },
  {
    value: "9:30 pm",
    stringValue: "2130",
    selected: false,
    disabled: false,
    index: 44
  },
  {
    value: "10:00 pm",
    stringValue: "2200",
    selected: false,
    disabled: false,
    index: 45
  },
  {
    value: "10:30 pm",
    stringValue: "2230",
    selected: false,
    disabled: false,
    index: 46
  },
  {
    value: "11:00 pm",
    stringValue: "2300",
    selected: false,
    disabled: false,
    index: 47
  },
  {
    value: "11:30 pm",
    stringValue: "2330",
    selected: false,
    disabled: false,
    index: 48
  }
];

export const CanStates = [
  { abr: "ON", state: "Ontario" },
  { abr: "QC", state: "Quebec" },
  { abr: "NS", state: "Nova Scotia" },
  { abr: "NB", state: "New Brunswick" },
  { abr: "MB", state: "Manitoba" },
  { abr: "BC", state: "British Columbia" },
  { abr: "PE", state: "Prince Edward Island" },
  { abr: "SK", state: "Saskatchewan" },
  { abr: "AB", state: "Alberta" },
  { abr: "NL", state: "Newfoundland and Labrador" }
];

export const UsStates = [
  { abr: "AL", state: "Alabama" },
  { abr: "AK", state: "Alaska" },
  { abr: "AZ", state: "Arizona" },
  { abr: "AR", state: "Arkansas" },
  { abr: "CA", state: "California" },
  { abr: "CO", state: "Colorado" },
  { abr: "CT", state: "Connecticut" },
  { abr: "DE", state: "Delaware" },
  { abr: "DC", state: "District Of Columbia" },
  { abr: "FL", state: "Florida" },
  { abr: "GA", state: "Georgia" },
  { abr: "HI", state: "Hawaii" },
  { abr: "ID", state: "Idaho" },
  { abr: "IL", state: "Illinois" },
  { abr: "IN", state: "Indiana" },
  { abr: "IA", state: "Iowa" },
  { abr: "KS", state: "Kansas" },
  { abr: "KY", state: "Kentucky" },
  { abr: "LA", state: "Louisiana" },
  { abr: "ME", state: "Maine" },
  { abr: "MD", state: "Maryland" },
  { abr: "MA", state: "Massachusetts" },
  { abr: "MI", state: "Michigan" },
  { abr: "MN", state: "Minnesota" },
  { abr: "MS", state: "Mississippi" },
  { abr: "MO", state: "Missouri" },
  { abr: "MT", state: "Montana" },
  { abr: "NE", state: "Nebraska" },
  { abr: "NV", state: "Nevada" },
  { abr: "NH", state: "New Hampshire" },
  { abr: "NJ", state: "New Jersey" },
  { abr: "NM", state: "New Mexico" },
  { abr: "NY", state: "New York" },
  { abr: "NC", state: "North Carolina" },
  { abr: "ND", state: "North Dakota" },
  { abr: "OH", state: "Ohio" },
  { abr: "OK", state: "Oklahoma" },
  { abr: "OR", state: "Oregon" },
  { abr: "PA", state: "Pennsylvania" },
  { abr: "RI", state: "Rhode Island" },
  { abr: "SC", state: "South Carolina" },
  { abr: "SD", state: "South Dakota" },
  { abr: "TN", state: "Tennessee" },
  { abr: "TX", state: "Texas" },
  { abr: "UT", state: "Utah" },
  { abr: "VT", state: "Vermont" },
  { abr: "VA", state: "Virginia" },
  { abr: "WA", state: "Washington" },
  { abr: "WV", state: "West Virginia" },
  { abr: "WI", state: "Wisconsin" },
  { abr: "WY", state: "Wyoming" }
];

export const repeatDropArray = [
  { text: "Daily", value: "D" },
  { text: "Weekly", value: "W" },
  { text: "Monthly", value: "M" },
  { text: "Specific", value: "S" }
];

export const dailyEveryDropArray = [
  { text: "1 day", value: 1 },
  { text: "2 days", value: 2 },
  { text: "3 days", value: 3 },
  { text: "4 days", value: 4 },
  { text: "5 days", value: 5 },
  { text: "6 days", value: 6 }
];

export const numberOfTimesDropArray = [
  { text: "Twice", value: 2 },
  { text: "3 times", value: 3 },
  { text: "4 times", value: 4 },
  { text: "5 times", value: 5 },
  { text: "6 times", value: 6 },
  { text: "7 times", value: 7 },
  { text: "8 times", value: 8 },
  { text: "9 times", value: 9 },
  { text: "10 times", value: 10 },
  { text: "11 times", value: 11 },
  { text: "12 times", value: 12 }
];

export const weeklyEveryDropArray = [
  { text: "1 week", value: 1 },
  { text: "2 weeks", value: 2 },
  { text: "3 weeks", value: 3 },
  { text: "4 weeks", value: 4 },
  { text: "5 weeks", value: 5 },
  { text: "6 weeks", value: 6 },
  { text: "7 weeks", value: 7 },
  { text: "8 weeks", value: 8 }
];

export const monthlyEveryDropArray = [
  { text: "1 month", value: 1 },
  { text: "2 months", value: 2 },
  { text: "3 months", value: 3 },
  { text: "4 months", value: 4 },
  { text: "5 months", value: 5 },
  { text: "6 months", value: 6 }
];
